import React from 'react';

import LandingLayout from '../layouts/landing.layout';

import Home from '../pages/home.page';
import Contact from '../pages/contact.page';
import LatestJob from 'pages/latest-job.page';
import OverviewPage from 'pages/overview.page';
import ServicesPage from 'pages/services.page';
import TermsOfServicePage from 'pages/terms-of-service.page';
import PrivacyPolicyPage from 'pages/privacy-policy.page';

export const landingRoutes = [
  {
    path: '/',
    element: <LandingLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'overview', element: <OverviewPage /> },
      { path: 'services', element: <ServicesPage /> },
      { path: 'terms-of-service', element: <TermsOfServicePage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'services', element: <ServicesPage /> },
      { path: 'latest-jobs', element: <LatestJob /> },
      { path: 'contact', element: <Contact /> },
    ],
  },
];
